/**
 * Comms Hub — what the detail dialog shows for a text RM sent (RM-392).
 *
 * Kapil, 10/6: "are we logging all of these texts in the comms hub?" They are
 * all there, but opening one showed the table's 120-character preview, so a
 * welcome text (about 290 characters) was cut off mid-sentence. The dialog
 * shows the whole text, who it went to and what it cost to send.
 *
 * Pure, so it is tested without the page (commsSmsDetail.spec.js).
 */

/**
 * @param {Object} row - a comms message row whose channel is 'sms'
 * @returns {{ to: string, text: string, size: string, notSent: string }}
 */
export function smsDetail(row = {}) {
  const payload = row.payload || {}
  const delivery = row.delivery || {}
  const providerId = String(row.providerMessageId || '')

  // "2 segments · 212 characters · GSM-7": what Twilio bills by.
  const parts = []
  if (delivery.segments > 0) parts.push(`${delivery.segments} segment${delivery.segments === 1 ? '' : 's'}`)
  if (delivery.chars > 0) parts.push(`${delivery.chars} characters`)
  if (delivery.encoding) parts.push(String(delivery.encoding))

  // A row can read "sent" without a text having left RM: outside production a
  // text to a number that isn't on the approved list is held, and a local run
  // with no Twilio account only logs it (lib/comms/channels/sms.js).
  let notSent = ''
  if (providerId.startsWith('held-nonprod-')) notSent = 'Held, not sent: outside production, texts go only to approved numbers.'
  else if (providerId.startsWith('local-echo-')) notSent = 'Not sent: a local run with no Twilio account only logs the text.'

  return {
    to: String(payload.to || ''),
    // The whole text, exactly as it was handed to the texting channel.
    text: typeof payload.text === 'string' ? payload.text : '',
    size: parts.join(' · '),
    notSent,
  }
}
